import { render, staticRenderFns } from "./Raffles.vue?vue&type=template&id=b38385ca&"
import script from "./Raffles.vue?vue&type=script&lang=ts&"
export * from "./Raffles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports